import script from "./ChatsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatsView.vue?vue&type=script&setup=true&lang=js"

import "./ChatsView.vue?vue&type=style&index=0&id=5428e304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5428e304"]])

export default __exports__